export const replaceTemplateVariables = (template, replacementJSON) => {
	if (!template) return "";
	// Merge multiple contexts (e.g. [formValues, staticFormConfig]): form/watch values must win
	// on duplicate keys — earlier implementation spread form config last and could clobber responses.
	if (Array.isArray(replacementJSON)) {
		replacementJSON = replacementJSON.reduce(
			(acc, curr) => ({ ...curr, ...acc }),
			{},
		);
	}

	// First, handle conditional blocks ({{#if}} ... {{/if}})
	template = template.replace(
		/\{\{#if\s+([^}]+)\}\}([\s\S]*?)\{\{\/if\}\}/g,
		(match, condition, content) => {
			const conditionParts = condition.trim().split(".");
			let value = replacementJSON;

			// Navigate to the nested value
			for (const part of conditionParts) {
				if (value === undefined) break;
				value = value[part];
			}

			// Check if the condition is truthy
			if (value && value !== "" && value !== "false" && value !== "0") {
				// Condition is true, return the content (will be processed for variables later)
				return content;
			} else {
				// Condition is false, return empty string
				return "";
			}
		}
	);

	// Then handle regular variable replacement
	return template.replace(/\{\{([^}]+)\}\}/g, (match, key) => {
		const expression = key.trim();
		const mathMatch = expression.match(/^(.+?)([+\-*/])(\d+)$/);

		if (mathMatch) {
			// Handle mathematical expressions
			const [, varPath, operator, number] = mathMatch;
			const keyParts = varPath.split(".");
			let value = replacementJSON;

			for (const part of keyParts) {
				if (value === undefined) break;
				value = value[part];
			}

			if (value === undefined) return match;

			const numValue = Number(value);
			if (isNaN(numValue)) return match;

			switch (operator) {
				case "+":
					return numValue + Number(number);
				case "-":
					return numValue - Number(number);
				case "*":
					return numValue * Number(number);
				case "/":
					return numValue / Number(number);
				default:
					return match;
			}
		} else {
			// Handle regular variable replacement
			const keyParts = expression.split(".");
			let value = replacementJSON;

			for (const part of keyParts) {
				if (value === undefined) break;
				value = value[part];
			}

			return value !== undefined ? value : match;
		}
	});
};
